export default {
  title: 'MyLink Metaverse staff ID Application',
  c1: 'https://mylink.oss-accelerate.aliyuncs.com/myHomeIcon/applyIdBg_en.png',
  c2: 'Activity Rule',
  c3: 'Every CMHK staff could claim Staff ID once, the sequence of distribution depends on the sequence of claim application.',
  c4: 'The system will distribute the Staff ID as soon as the application is submitted, you can replace the previous Meta ID by clicking “NEW” to Metaverse HomePage within 14 days, or it would be expired if without replacement after 14 days.',
  c5: 'Application is submitted successfully',
  c6: 'Network is unavailable, please try again',
  c7: 'Staff ID can not be re-claimed ',
  c8: 'Staff ID can not be claimed by non staff users',
  C9: 'Meta ID Card'
}
